import React, { useState } from "react";
import "./Organization.css";
import OrganizationsList from "./OrganizationsList";
import SelectedOrganization from "./SelectedOrganization";

function Organization() {
    const [selectedOrganization, setSelectedOrganization] = useState(null);

    const handleSelectedOrganization = (org) => {
        console.log("Selected organization:", org);
        setSelectedOrganization(org);
    };

    return (
        <div className="Organization">
            <div className="Organization_list">
                <h2>Organisations</h2>
                <OrganizationsList onSelectOrganization={handleSelectedOrganization} />
            </div>

            <div className="Organization_selected">
                {selectedOrganization ? (
                    <SelectedOrganization organization={selectedOrganization} />
                ) : (
                    <p></p>
                )}
            </div>
        </div>
    );
}

export default Organization;
